export const getURLs = () => (dispatch) => {

    return fetch(process.env.PUBLIC_URL + "/config.json", {
        method: 'GET',
        dataType: "json"
      }).then(response => {
        return response.json()
    });
}

export const getProtectedParams = (url) => (dispatch) => {

    return fetch(url + "/protectedParameters/settings", {
        method: 'GET',
        dataType: "json",
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(response => {
        if(response.ok) {
            return response.json()
          } else {
            return response.json().then(json => {
              return {
                contentType: response.headers.get("Content-Type"),
                json: json
              }
            })
          }    
    });
}

export const verifierSimple = (url, data) => (dispatch) => {

    return fetch(url + "/verifier.simple", {
        method: 'PUT',
        dataType: "json",
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(response => {
        if(response.ok) {
            return response.json()
          } else {
            return response.json().then(json => {
              return {
                contentType: response.headers.get("Content-Type"),
                json: json
              }
            })
          }
    });
}

export const createSimpleDS = (url, data) => (dispatch) => {

    return fetch(url + "/es.create/data", {
        method: 'POST',
        dataType: "json",
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(response => {
        if(response.ok) {
            return response.json()
          } else {
            return response.json().then(json => {
              return {
                contentType: response.headers.get("Content-Type"),
                json: json
              }
            })
          }
    });
}

export const createHandwrittenDS = (url, data) => (dispatch) => {

    return fetch(url + "/creator", {
        method: 'POST',
        dataType: "json",
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(response => {
        if(response.ok) {
            return response.json()
          } else {
            return response.json().then(json => {
              return {
                contentType: response.headers.get("Content-Type"),
                json: json
              }
            })
          }
    });
}

export const verifierFull = (url, data) => (dispatch) => {

    return fetch(url + "/verifier.full", {
        method: 'PUT',
        dataType: "json",
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(response => {
        if(response.ok) {
            return response.json()
          } else {
            return response.json().then(json => {
              return {
                contentType: response.headers.get("Content-Type"),
                json: json
              }
            })
          }
    });
}